import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { UAVCommand } from '../../model/uavcommand';

export interface UAVCommandState extends EntityState<UAVCommand> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'UAVCommand' })
export class UAVCommandStore extends EntityStore<UAVCommandState> {

  constructor() {
    super();

  }

}
